import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AppState } from '../../app.service';
import { config } from 'app/shared/smartadmin.config';


@Injectable()
export class AdminPOSGuard implements CanActivate {
  constructor(private router: Router, private actr: ActivatedRoute, public appState: AppState) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
    const role = this.appState.get('role');
    if ((role === 'Admin User' || role === 'Admin POS' || role === 'RS Supervisor' || role === 'Billing User' || role === 'RFA User') && !config.parksWithDisabledAdminRoutes.includes(config.currentPark.code)) {
      return true;
    } else {
      this.router.navigate(['/profile']);
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/guards/admin-pos.guard.ts